import { BRAND } from '@onuw/roles-data'
import { Link } from 'react-router'
import { Prose } from '../ui/Prose'

export const notFoundMeta = () => [
  { title: `Page not found – ${BRAND.name}` },
  { name: 'robots', content: 'noindex' },
]

export const meta = notFoundMeta

/**
 * An address the site does not have. Pages answers such an address with public/404.html; this is the same page for
 * a link followed inside the app, and for a role or guide that does not exist.
 */
export function NotFound() {
  return (
    <Prose title="Page not found" lead="There is nothing at this address.">
      <p>
        Head back to the <Link to="/">home page</Link> to start or join a table, or browse{' '}
        <Link to="/roles/">the roles</Link>, <Link to="/rules/">the rules</Link> and{' '}
        <Link to="/guides/">the guides</Link>.
      </p>
    </Prose>
  )
}

export default NotFound
